import { execute, INSERT, SELECT, UPDATE } from "@/utils/database_module";
import { Product, Review, User } from "@/utils/types";

const reviews = {

    getAll : async (product_id : number) => {
        const reviews = (await SELECT("reviews", { conditions: [{  column: "product_id",  operator: "=",  value: product_id,},{  column: "is_deleted",  operator: "=",  value: 0,}, ],order : "date DESC" })) as Review[];
         
        const emailsList = reviews.map((r) => `'${r.user_id}'`);
        const emailsStr = emailsList.length!=0 ?`WHERE id IN (${emailsList.join(" ,")})` : ''

        const users = (await execute( `SELECT first_name,last_name, id , email , profile_pic FROM users ${emailsStr} ` )) as User[];
      
        // Attach user info to each review
        for (const review of reviews) {
            const user = users.find((user) => user.id === review.user_id);
            if (user) {
              review.profile_pic = user.profile_pic;
              review.username = `${user.first_name} ${user.last_name}`;
              review.email = `${user.email}`;
            }
            
        }
        return reviews
    },

    insert : async (review : Review) => {
        await INSERT("reviews", review);

        const products = await SELECT("products", {conditions : [{column : "id" , operator : "=" , value : review.product_id}]})as Product[]
        const product = products[0]
        const newRating = (product.rating!*(product.nb_ratings!) + review.rating!)/(product.nb_ratings!+1)
        await UPDATE('products', {rating:newRating , nb_ratings : product.nb_ratings!+1 } , [{column : "id" , operator : "=" , value : review.product_id}]);
    },

    delete : async (id : number) => {
        return await UPDATE("reviews" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    }
    
 }

 export default reviews